import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Download, Trash2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState(null);

  const load = async () => {
    try { setSubs((await api.get("/admin/newsletter")).data); }
    catch { setSubs([]); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Unsubscribe this email?")) return;
    try { await api.delete(`/admin/newsletter/${id}`); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Failed"); }
  };

  const download = () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter.csv`;
    window.open(url, "_blank");
  };

  if (subs === null) return <div className="text-sm text-zinc-500">Loading…</div>;

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="overline text-zinc-500">Marketing</div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Newsletter subscribers</h1>
          <p className="text-sm text-zinc-500 mt-1">{subs.length} active subscriber{subs.length !== 1 ? "s" : ""}.</p>
        </div>
        <button onClick={download} className="btn-primary inline-flex items-center gap-2" data-testid="download-newsletter-csv">
          <Download size={14} /> Download CSV
        </button>
      </div>

      {subs.length === 0 ? (
        <div className="rounded-xl border border-dashed border-zinc-200 p-10 text-center">
          <Mail size={28} className="mx-auto text-zinc-300 mb-3" />
          <p className="text-sm text-zinc-500">No subscribers yet. Add the signup block to your landing page.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-zinc-200 bg-white overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[600px]">
              <thead className="bg-zinc-50 text-zinc-500 text-xs">
                <tr>
                  <th className="text-left px-4 py-3">Email</th>
                  <th className="text-left px-4 py-3">Name</th>
                  <th className="text-left px-4 py-3">Source</th>
                  <th className="text-left px-4 py-3">Subscribed</th>
                  <th className="text-right px-4 py-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                {subs.map((s) => (
                  <tr key={s.id} className="border-t border-zinc-100" data-testid={`subscriber-${s.id}`}>
                    <td className="px-4 py-3 font-semibold break-all">{s.email}</td>
                    <td className="px-4 py-3">{s.name || "—"}</td>
                    <td className="px-4 py-3"><span className="text-xs bg-zinc-100 px-2 py-0.5 rounded">{s.source}</span></td>
                    <td className="px-4 py-3 text-xs text-zinc-500 whitespace-nowrap">{new Date(s.subscribed_at).toLocaleDateString()}</td>
                    <td className="px-4 py-3 text-right">
                      <button onClick={() => remove(s.id)} className="p-1.5 hover:bg-red-50 text-red-500 rounded" data-testid={`unsub-${s.id}`}>
                        <Trash2 size={14} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
